import React, { FC } from 'react'
import { breakpointUp, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

const StyledImage = styled.img`
  display: block;
  width: 170px;
  max-width: 170px;
   ${s({ boxShadow: 2 })}

  ${breakpointUp('md')} {
    max-width: 170px;
  }
`

type Props = {
  title: string
  mainImageUrl: string | undefined
}

export const CarouselImage: FC<Props> = ({ title, mainImageUrl }) => {
  return <StyledImage alt={title} src={mainImageUrl} />
}
